<template>
  <div class="dashboard__analytics">
    <div class="row m-0 dashboard__analytics--options" style="border-bottom: 1px solid #E8EBEE">
      <div class="options__tabs d-flex" >
        <p class="dashboard__analytics--title mr-2">Analytics</p>
        <button v-for="tab in tabs" :key="tab.id"
          :class="setTabs(tab.status)"
          @click="selectedTab === tab.name.toLowerCase() ? '' : fetchAnalytics(tab.name.toLowerCase(), thisYear), switchTab(tab.name)"  >
          {{tab.name}}
        </button>
      </div>
      <div class="dashboard__analytics--tableperiod">
        <p class="tableperiod__title">Table Period :</p>
        <div class="options__defaultdropdown w-auto pr-1">
          <b-input-group>
            <b-dropdown>
              <template slot="button-content">
                <p>{{selectedYear}}</p>
              </template>
              <b-dropdown-item v-for="option in yearList" :key="option.text"
                @click="chooseYear(option.text)">
                <span>{{option.text}}</span>
              </b-dropdown-item>
            </b-dropdown>
            <img class="options__defaultdropdown--imgabsolute"
                 src="@/assets/image/icon/arrow-down-full-gray.svg">
          </b-input-group>
        </div>
      </div>
    </div>
    <div style="padding: 0px 19px;">
      <div class="m-0 mt-2 d-flex justify-content-end w-100 " v-if="itemAnalytics">
        <div class="mr-4" v-for="item in itemAnalytics.legends" :key="item.id">
          <div class="legends d-flex align-items-center" >
            <div v-if="item.label === 'Total Container'" style="height: 10px;
            width: 15px;
            background-color: #1D3354;"></div>

            <div v-else-if="item.label === 'Total CBM'" style="height: 10px;
            width: 15px;
            background-color: #C4232A;"></div>

            <div v-else style="height: 10px;
            width: 15px;
            background-color: #FD9E00;"></div>
            <p :style="setTextColor(item.label)" class="ml-2">{{item.label}}</p>
          </div>
        </div>
      </div>
      <div class="my-5 d-flex justify-content-center align-items-center"
        v-if="(isLoadingAnalytics || updateData || errorAnalytics) && !isEmpty">
        <half-circle-spinner
          :animation-duration="1500"
          :size="50"
          color="#1D3354"
          class="mx-auto"
        />
      </div>
      <div v-else-if="isEmpty" class="d-flex justify-content-center align-items-center flex-wrap">
        <div style="margin-top: 180px;">  
          <div class="d-flex justify-content-center mb-3">
            <img src="@/assets/image/icon/Signal-grey.svg" alt="">
          </div>
          <p style="color:#D2D6DD;">You don’t have any trasaction yet.</p>
        </div>
        
      </div>
      <div class="dashboard__analytics--chart" v-else>
        <template v-if="!chartTrue">
          <bar-chart
          :masterdata="masterdata"
          :height="height"
          :width="width"/>
        </template>
        <template v-if="chartTrue">
          <line-chart
          :masterdata="masterdata"
          :height="height"
          :width="width"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/dashboard/chart/BarChart.vue'
import LineChart from '@/components/dashboard/chart/LineChart.vue'
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import _ from 'lodash'
import * as moment from 'moment'

export default {
  name: 'Analytics',
  components: {
    BarChart,
    LineChart,
    HalfCircleSpinner
  },
  data: () => ({
    masterdata: {
      datacollection: {
        labels: [],
        datasets: []
      },
      options: {
        legend: {
          defaultFontColor: '#686868',
          defaultFontFamily: "'OpenSans'"
        },
        responsive: true,
        maintainAspectRatio: false
      }
    },
    tabs: [
      {id: 1, name: 'Spending', status: 'active'},
      {id: 2, name: 'Volume', status: 'inactive'}
    ],
    width: 400,
    height: 200,
    updateData: false,
    thisYear: moment().format('YYYY'),
    yearList: [],
    selectedYear: moment().format('YYYY'),
    selectedTab: 'spending',
    chartTrue: true
  }),
  mounted () {
    this.setYearList()
    this.fetchAnalytics('spending', this.thisYear)
  },
  computed: {
    ...mapGetters({
      itemAnalytics: 'dashboard/itemAnalytics',
      isLoadingAnalytics: 'dashboard/isLoadingAnalytics',
      errorAnalytics: 'dashboard/errorAnalytics'
    }),
    isEmpty () {
      if (this.itemAnalytics && this.itemAnalytics.length < 2) {
        const data = this.itemAnalytics.datasets[0].data
        let count = 0
        data.forEach((el) => {
          count += el
        })
        if (count > 0) {
          return false
        } else {
          return true
        }
      } else {
        if (this.itemAnalytics !== undefined) {
          const data = this.itemAnalytics.datasets
          let count = 0
          data.forEach((el) => {
            el.data.forEach((index) => {
              count += index
            })
          }) 
          if (count > 0) {
            return false
          } else {
            return true
          }
        }
      }
    }
  },
  methods: {
    async fetchAnalytics (type, year) {
      await this.$store.dispatch('dashboard/FETCH_ANALYTICS', {type, year})
      await this.setChartData(this.selectedTab)
      this.updateData = false
    },
    setSpendingChart () {
      if (!this.isEmpty) {
        return new Promise((resolve) => {
          var ctx = document.getElementById('line-chart').getContext('2d')
          var gradientFill = ctx.createLinearGradient(0, 0, 0, 600)
          gradientFill.addColorStop(0, 'rgba(29, 51, 84, 0.5)')
          gradientFill.addColorStop(1, 'rgba(29, 51, 84, 0)')
          this.updateData = true
          this.masterdata.datacollection.labels = this.itemAnalytics.labels
          this.masterdata.datacollection.datasets = [
            {
              label: this.itemAnalytics.datasets[0] ? this.itemAnalytics.datasets[0].label : '',
              data: this.itemAnalytics.datasets[0] ? this.itemAnalytics.datasets[0].data : '',
              borderColor: '#1D3354',
              borderWidth: 2,
              backgroundColor: gradientFill,
              pointBackgroundColor: '#1D3354'
            }
          ]
          this.masterdata.options = {
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  callback (label) {
                    if (_.isNil(label)) {
                      return label
                    } else if (label === 0) {
                      return label
                    } else if (label < 99999 && label > 999) {
                      return `${Math.round((label / 1000))} K`
                    } else if (label > 999999) {
                      return `${Math.round((label / 1000000))} M`
                    }
                    return label
                  }
                },
                gridLines: {
                  display: true
                }
              }],
              xAxes: [{
                gridLines: {
                  display: false
                }
              }]
            },
            elements: {
              line: {
                tension: 0,
                borderWidth: 4
              }
            },
            title: {
              position: 'left',
              text: 'Amount in IDR',
              display: true,
              fontStyle: 'bold',
              lineHeight: 1.42
            },
            tooltips: {
              callbacks: {
                label (tooltipItem) {
                  return `IDR ${tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0]}`
                  // return `${tooltipItem | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true })}`
                }
              }
            },
            legend: {
              display: false
            }
          }
          return resolve()
        })
      }
    },
    setTextColor (item) {
      if (item === 'Total Container') {
        return 'color: #1D3354;'
      } else if (item === 'Total CBM') {
        return 'color: #C4232A;'
      } else {
        return 'color: #FD9E00;'
      }
    },
    setVolumeChart () {
      return new Promise((resolve) => {
        this.updateData = true
        this.masterdata.datacollection.labels = this.itemAnalytics.labels
        this.masterdata.datacollection.datasets = [
          {
            label: this.itemAnalytics.datasets[0] ? this.itemAnalytics.datasets[0].label : '',
            data: this.itemAnalytics.datasets[0] ? this.itemAnalytics.datasets[0].data : '',
            // data:[20,10,30],
            backgroundColor: '#1D3354'
          },
          {
            label: this.itemAnalytics.datasets[1] ? this.itemAnalytics.datasets[1].label : '',
            data: this.itemAnalytics.datasets[1] ? this.itemAnalytics.datasets[1].data : '',
            // data:[10,20,30],
            backgroundColor: '#c3414e'
          },
          {
            label: this.itemAnalytics.datasets[2] ? this.itemAnalytics.datasets[2].label : '',
            data: this.itemAnalytics.datasets[2] ? this.itemAnalytics.datasets[2].data : '',
            // data:[15,10,30],
            backgroundColor: '#ffc400'
          }
        ]
        this.masterdata.options = {
          scales: {
            yAxes: [{
              ticks: {
                min: 0,
                beginAtZero: true,
                callback (label) {
                  if (_.isNil(label)) {
                    return label
                  } else {
                    return `${label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0]}`
                  }
                }
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false
              }
            }]
          },
          tooltips: {
            callbacks: {
              label (tooltipItem) {
                let unit = ''
                if (tooltipItem.datasetIndex === 2) {
                  unit = 'Kg'
                } else if (tooltipItem.datasetIndex === 1) {
                  unit = 'CBM'
                } else if (tooltipItem.datasetIndex === 0) {
                  unit = 'Container'
                }
                return `${unit}: ${tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0]}`
              }
            }
          },
          legend: {
            display: false
          }
        }
        return resolve()
      })
    },
    setColor (item) {
      if (item === 'Total Last Month' || item === 'Total This Month' || item === 'Total Container') {
        return 'legends__blue'
      }
      if (item === 'Total CBM') {
        return 'legends__red'
      }
      if (item === 'Total Kg' || item === 'Total This Year') {
        return 'legends__yellow'
      }
    },
    setTabs (item) {
      if (item === 'active') {
        return 'button__chartbluesquere mr-2'
      }
      return 'button__chartwhitesquere mr-2'
    },
    switchTab (item) {
      this.selectedTab = item.toLowerCase()
      if (item.toLowerCase() === 'spending') {
        this.tabs[0].status = 'active'
        this.tabs[1].status = 'inactive'
      }
      if (item.toLowerCase() === 'volume') {
        this.tabs[1].status = 'active'
        this.tabs[0].status = 'inactive'
      }
    },
    setYearList () {
      for (let i = this.thisYear; i >= 2018; i--) {
        this.yearList.push({
          text: i.toString()
        })
      }
    },
    chooseYear (item) {
      this.selectedYear = item
    },
    getImage (item) {
      let image = ''
      if (item === 'Total Last Month') {
        image = require('@/assets/image/icon/dashboard-last-month.svg')
      }
      if (item === 'Total This Month') {
        image = require('@/assets/image/icon/dashboard-this-month.svg')
      }
      if (item === 'Total This Year') {
        image = require('@/assets/image/icon/dashboard-this-year.svg')
      }
      if (item === 'Total Container') {
        image = require('@/assets/image/icon/dashboard-total-container.svg')
      }
      if (item === 'Total CBM') {
        image = require('@/assets/image/icon/dashboard-total-cbm.svg')
      }
      if (item === 'Total Kg') {
        image = require('@/assets/image/icon/dashboard-total-kg.svg')
      }
      return image
    },
    setChartData (item) {
      return new Promise((resolve) => {
        if (item === 'spending') {
          this.chartTrue = true
          this.setSpendingChart()
        }
        if (item === 'volume') {
          this.chartTrue = false
          this.setVolumeChart()
        }
        return resolve()
      })
    }
  },
  watch: {
    selectedYear (data) {
      if (!_.isNil(data)) {
        this.fetchAnalytics(this.selectedTab, data)
      }
    },
    async selectedTab (data) {
      if (!_.isNil(data)) {
        this.selectedYear = moment().format('YYYY')
        await this.setChartData(data)
        this.updateData = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Analytics.vue